// The app: the shell and its router (app/), the screens (screens/), and the
// board they are played on (board/). See SCREENS.md.
import { createRoot } from "react-dom/client";
import "./app.css";
import { Root } from "./app/App.tsx";
import { registerServiceWorker } from "./app/sw.ts";
import { keepTaps } from "./app/press.ts";

registerServiceWorker();
keepTaps();
// What the page drew before the app ran (index.html), for the app to keep on
// the screen until it has something of its own.
const root = document.getElementById("root")!;
window.__placeholder = root.innerHTML;
createRoot(root).render(<Root />);
